import { render, staticRenderFns } from "./ZonasModalNuevo.vue?vue&type=template&id=e5d09208&scoped=true&"
import script from "./ZonasModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./ZonasModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./ZonasModalNuevo.vue?vue&type=style&index=0&id=e5d09208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d09208",
  null
  
)

export default component.exports